// src/components/SmsTest.js

import React, { useState } from 'react';
import Navbar from "./Navbar";
import '../styles/SmsTest.css';

function SmsTest({ onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('+19086457788');
  const [messageBody, setMessageBody] = useState('I want to make an appointment to facial procedure');
  const [customMessage, setCustomMessage] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleSendSms = () => {
    const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(messageBody)}`;
    window.location.href = smsLink;
  };

  const handleCopyLink = () => {
    const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(messageBody)}`;
    navigator.clipboard.writeText(smsLink).then(() => {
      alert('SMS link copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };

  const predefinedMessages = [
    'I want to make an appointment to facial procedure',
    'I would like to schedule a consultation',
    'Please send me more information about your services',
    'I need to reschedule my appointment',
  ];

  return (
    <div className="sms-test-container">
      <Navbar menuOpen={menuOpen} toggleMenu={toggleMenu} onLogout={onLogout} />
      
      <div className="sms-test-content">
        <h1>SMS Test Page</h1>
        <p className="description">Test SMS link functionality by configuring phone number and message below.</p>

        <div className="sms-form">
          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number:</label>
            <input
              type="tel"
              id="phoneNumber"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="+1234567890"
              className="form-input"
            />
            <small className="help-text">Include country code (e.g., +1 for US)</small>
          </div>

          <div className="form-group">
            <label>Message Template:</label>
            <div className="message-type-selector">
              <label className="radio-label">
                <input
                  type="radio"
                  checked={!customMessage}
                  onChange={() => setCustomMessage(false)}
                />
                <span>Predefined Messages</span>
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  checked={customMessage}
                  onChange={() => setCustomMessage(true)}
                />
                <span>Custom Message</span>
              </label>
            </div>
          </div>

          {!customMessage ? (
            <div className="form-group">
              <label htmlFor="predefinedMessage">Select Message:</label>
              <select
                id="predefinedMessage"
                value={messageBody}
                onChange={(e) => setMessageBody(e.target.value)}
                className="form-select"
              >
                {predefinedMessages.map((msg, index) => (
                  <option key={index} value={msg}>{msg}</option>
                ))}
              </select>
            </div>
          ) : (
            <div className="form-group">
              <label htmlFor="messageBody">Custom Message:</label>
              <textarea
                id="messageBody"
                value={messageBody}
                onChange={(e) => setMessageBody(e.target.value)}
                placeholder="Enter your message here..."
                rows="4"
                className="form-textarea"
              />
              <small className="help-text">Character count: {messageBody.length}</small>
            </div>
          )}

          <div className="preview-section">
            <h3>Preview SMS Link:</h3>
            <div className="link-preview">
              <code>sms:{phoneNumber}?body={messageBody}</code>
            </div>
          </div>

          <div className="button-group">
            <button onClick={handleSendSms} className="btn btn-primary">
              📱 Open SMS App
            </button>
            <button onClick={handleCopyLink} className="btn btn-secondary">
              📋 Copy Link
            </button>
          </div>

          <div className="info-section">
            <h3>How it works:</h3>
            <ul>
              <li>The <strong>sms:</strong> protocol opens the default SMS/messaging app on your device</li>
              <li>On mobile devices, this will open the native messaging app</li>
              <li>On desktop, behavior depends on the operating system and installed apps</li>
              <li>The message body is pre-filled but can be edited before sending</li>
            </ul>
          </div>

          <div className="test-examples">
            <h3>Quick Test Examples:</h3>
            <div className="example-buttons">
              <button 
                onClick={() => {
                  setPhoneNumber('+19086457788');
                  setMessageBody('I want to make an appointment to facial procedure');
                  setCustomMessage(false);
                }}
                className="btn btn-example"
              >
                Facial Appointment
              </button>
              <button 
                onClick={() => {
                  setPhoneNumber('+19086457788');
                  setMessageBody('I would like to schedule a consultation');
                  setCustomMessage(false);
                }}
                className="btn btn-example"
              >
                Consultation Request
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmsTest;
